import styled from "styled-components"

export const fontSize = "1.5rem"
export const paddingValue = "2rem"

export const yellow = "#fdee6c"
export const red = "#f25f5c"
export const blue = "#247ba0"
export const lightblue = "#60b6db"
export const black = "#424242"
export const green = "#427F7B"
export const lightgreen = "#5baaa5"
export const mint = "#B5C8C2"

export const section_header = "3.5em"
export const title_header = "3.0em"
export const subtitle_header = "2.5em"

export const Title = styled.h1`
  color: ${black};
  font-weight: bold;
  font-size: ${section_header};
  text-align: center;
  text-decoration: underline;
`
